import { queryClient } from "@/lib/reactQuery";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { deleteExpense } from "@/api/expenses/delete-expenses";

export const deleteExpenses = () => {
  const { mutateAsync: deleteExpenseFn } = useMutation({
    mutationKey: ["deleteExpense"],
    mutationFn: deleteExpense,
    onSuccess: () => {
      toast.success("Expense deleted successfully");
      queryClient.invalidateQueries({ queryKey: ["expenses"] }); // Refetch the expenses to update the table
    },
    onError: () => {
      toast.error("Error deleting expense");
    },
  });
  return { deleteExpenseFn };
};
